export default "__VITE_ASSET__DwenGLWv__"